import React from 'react';
import { Spinner } from 'react-bootstrap';

interface TableStateRowProps {
  colSpan: number;
  loading: boolean;
  message: string;
}

// The single full-width row a table shows when it has no rows: a spinner on the first
// load, otherwise the empty message.
const TableStateRow: React.FC<TableStateRowProps> = ({
  colSpan,
  loading,
  message,
}) => (
  <tr>
    <td colSpan={colSpan} className="table-empty">
      {loading ? <Spinner /> : message}
    </td>
  </tr>
);

export default TableStateRow;
